import React from 'react';

import { Field } from 'react-final-form';
import { useDispatch } from 'react-redux';

import AddMinusButton from 'components/shared/AddMinusButton';
import Icon from 'components/shared/Icon';
import Trash2 from 'components/shared/Icon/icons/Trash2';
import Text from 'components/shared/Typography/Text';
import { editThunk } from 'store/assets/thunks';
import { DOCUMENT_MIME_TYPES } from 'utils/asset';

import styles from './index.module.css';

import Upload from './index';

function Sheets({ files = [], form, onOpenModal, onDelete, name, onAfterEdited }) {
  const dispatch = useDispatch();
  const type = 'document';
  const handleEdit = (id) => {
    dispatch(
      editThunk({
        id,
        modalTitle: 'Edit Document',
        onDelete: (asset) => onDelete(type)(asset, form),
        onAfterEdited: (asset) => onAfterEdited(type)(asset, form),
      }),
    );
  };

  return (
    <>
      {!!files.length && (
        <div className={styles.sheetsWrapper}>
          <div className={styles.sheets}>
            {files.map((file, i) => (
              <div key={i} className={styles.sheetsItem}>
                <Text accent className={styles.sheetName}>
                  {file.name}
                </Text>
                <div className={styles.roomActions}>
                  <Text accent className={styles.edit} onClick={() => handleEdit(file.id)}>
                    Edit
                  </Text>
                  <button type="button" className={styles.sheetBtn} onClick={() => onDelete(type)(file, form)}>
                    <Icon component={Trash2} className={styles.icon} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <AddMinusButton onClick={() => onOpenModal(type, form)} />
        </div>
      )}
      {!files.length && (
        <Upload
          onOpenModal={() => onOpenModal(type, form)}
          allowedMimeTypes={DOCUMENT_MIME_TYPES}
          contentType="documents"
          buttonActionType="add"
        />
      )}

      <Field name={name} render={() => null} />
    </>
  );
}

export default Sheets;
